<template>
<div class="block-operation" v-if="isOperationVisible">
   <div class="d-flex flex-wrap">
    <div class="block-operation__operation-btn mt-2 mr-4 px-2 d-flex align-items-center justify-content-center"
     @click="selectOperation"
      :class="{selected: data.isSelected}">
      {{data.name}}
    </div>
  </div>
  <div class="ml-4 d-flex flex-column" v-if="data.isSelected && data.children">
    <CalculatePriceBlockOperation v-for="child in data.children" :key="child.id" :data="child" class="mt-3" @selectOperation="(data) => updateOperation(child.id, data)" />
  </div>
  <div class="mt-1 ml-4" v-if="data.preset && (data.preset.y_axis_map || data.preset.extra_rig100 || data.preset.width) && data.isSelected">
    <div class="d-flex flex-wrap">
        <div class="block-operation__operation-btn mt-2 mr-4 px-2 d-flex align-items-center justify-content-center" v-for="yAxis in data.preset.y_axis_map"  :key="yAxis" :class="{selected: yAxis === selectedYAxis}" @click="selectYAxis(yAxis)">
        <span class="block-operation__y-axis" :title="yAxis">{{yAxis}}</span>
      </div>
    </div>
    <div class="d-flex align-items-center w-50" v-if="data.preset.extra_rig100">
      <span class="mr-1">Укажите размер новой оснастки</span>
      <input placeholder="ширина" type="text" autocomplete="off" class="form-control" v-model="inputRigWidthValue">
      <span class="mx-1">x</span>
      <input placeholder="высота" type="text" autocomplete="off" class="form-control" v-model="inputRigHeightValue">
    </div>
    <div class="d-flex align-items-center w-50" v-if="data.preset.width">
      <span class="mr-1">Укажите размер материала</span>
      <input placeholder="ширина" type="text" autocomplete="off" class="form-control" v-model="inputRigWidthValue">
      <span class="mx-1">x</span>
      <input placeholder="высота" type="text" autocomplete="off" class="form-control" v-model="inputRigHeightValue">
    </div>
  </div>
</div>

</template>
<script>

export default {
  name: 'CalculatePriceBlockOperation',
  props: {
    data: {
      default: () => {
        return {}
      }
    }
  },
  data: () => {
    return {
      selectedYAxis: null,
      inputRigWidthValue: null,
      inputRigHeightValue: null
    }
  },
  methods: {
    selectOperation () {
      if (this.data.children) {
        this.data.children.forEach(children => {
          children.isSelected = false
        })
        this.data.children = [...this.data.children]
      }
      this.$emit('selectOperation', { isSelected: !this.data.isSelected })
    },
    updateOperation (childId, data) {
      const childrenIndex = this.data.children.findIndex(x => x.id === childId)
      this.data.children.forEach(children => {
        children.isSelected = false
      })
      this.data.children[childrenIndex] = { ...this.data.children[childrenIndex], isSelected: data.isSelected }
      this.data.children = [...this.data.children]
    },
    selectYAxis (data) {
      if (this.selectedYAxis === data) {
        this.data.selectedPreset = { ...this.data.selectedPreset, yaxis: undefined }
        this.selectedYAxis = undefined
      } else {
        this.data.selectedPreset = { ...this.data.selectedPreset, yaxis: data }
        this.selectedYAxis = data
      }
    },
    checkThatContainsCheckedChildrens (operation) {
      if (operation.children) {
        return operation.children.some(x => this.checkThatContainsCheckedChildrens(x))
      } else {
        return operation.checked || typeof (operation.checked) === 'undefined'
      }
    }
  },
  watch: {
    inputRigWidthValue: function (newValue) {
      if (!newValue) {
        this.data.selectedPreset = { ...this.data.selectedPreset, rigWidth: null }
      } else {
        this.data.selectedPreset = { ...this.data.selectedPreset, rigWidth: newValue }
      }
    },
    inputRigHeightValue: function (newValue) {
      if (!newValue) {
        this.data.selectedPreset = { ...this.data.selectedPreset, rigHeigh: null }
      } else {
        this.data.selectedPreset = { ...this.data.selectedPreset, rigHeigh: newValue }
      }
    },
    isSelected: function (newValue) {
      if (!newValue) {
        delete this.data.selectedPreset
        this.selectedYAxis = undefined
        this.inputRigWidthValue = null
        this.inputRigHeightValue = null
      }
    }
  },
  computed: {
    isOperationVisible () {
      return this.checkThatContainsCheckedChildrens(this.data)
    },
    isSelected () {
      return this.data.isSelected
    }
  },
  created () {
    if (this.data.preset && this.data.preset.y_axis_map) {
      this.data.selectedPreset = undefined
      this.selectedYAxis = undefined
    }
  }
}
</script>

<style lang="scss" scoped>

.block-operation {
  &__operation-btn {
    cursor: pointer;
    position: relative;
    height: 38px;
    min-width: 80px;
    border-radius: 4px;
    box-shadow: inset 0 1px 0 rgba(40, 189, 139, 0.15);
    background-color: #e9f8f3;
    color: #28bd8b;
    max-width: 400px;

    &.selected {
      background-color: #28bd8b;
      color: #fff;
    }
  }

  &__operation-input {
    max-width: 200px;
  }

  &__y-axis{
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>
